module.exports = __webpack_public_path__ + "img/ill_graphics@2x.e3d50b59.png";